module.exports = __webpack_public_path__ + "img/donate.0050f4a8.webp";